export const orderDetailsMenuData = [
  {
    id: 1,
    name: "order-summary",
  },
  {
    id: 2,
    name: "seller-info",
  },

  {
    id: 3,
    name: "delivery-man-info",
  },
  {
    id: 4,
    name: "track-order",
  },
];
export const orderDetailsMenuDataForParcel = [
  {
    id: 1,
    name: "order-summary",
  },

  {
    id: 2,
    name: "delivery-man-info",
  },
  {
    id: 3,
    name: "track-order",
  },
];
